import { render } from "./opsgenie.vue?vue&type=template&id=51e45784&scoped=true"
import script from "./opsgenie.vue?vue&type=script&lang=js"
export * from "./opsgenie.vue?vue&type=script&lang=js"

import "./opsgenie.vue?vue&type=style&index=0&id=51e45784&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e45784"]])

export default __exports__